import { Box } from '@mui/material'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { FlexBox } from 'components/Box'
import { SaveButton, TextField } from 'components/Form'
import Hint from 'components/Hint'

import type { Schema } from './schema'

const SUBMIT_BUTTON_OFFSET_TOP: number = 1.25

type Props = {
  disabled: boolean
  formId: string
}

export const Form = ({ disabled, formId }: Props): React.JSX.Element => {
  const { t } = useTranslation('features/yieldbirdWrapperAgent', { keyPrefix: 'form' })
  const {
    control,
    formState: { isValid },
  } = useFormContext<Schema>()

  return (
    <FlexBox
      axis='x'
      sx={{ alignItems: 'flex-start', gap: 2 }}
    >
      <Box>
        <TextField
          control={control}
          disabled={disabled}
          label={t('url.label')}
          name='url'
          placeholder={t('url.placeholder')}
        />

        <Hint content={t('url.hint')} />
      </Box>

      <Box sx={{ pt: SUBMIT_BUTTON_OFFSET_TOP }}>
        <SaveButton
          formId={formId}
          loading={disabled}
          text={t('submit')}
          touched
          valid={isValid}
        />
      </Box>
    </FlexBox>
  )
}
